/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360EntitiesRetailerApiBrandListItem {
    ID?: number;
    Name?: string;
    /**
     * 0 = Pending, 1 = Rejected, 2 = Approved
     */
    Status?: Open360EntitiesRetailerApiBrandListItem.StatusEnum;
}
export namespace Open360EntitiesRetailerApiBrandListItem {
    export type StatusEnum = 0 | 1 | 2;
    export const StatusEnum = {
        NUMBER_0: 0 as StatusEnum,
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiBrandListItem.ts